// extracted by mini-css-extract-plugin
module.exports = {"infoModalContent":"Header_infoModalContent__39O0P"};